export default "__VITE_ASSET__d84ff6e6__"